<template lang="html">
  <input type="text" :value="formattedValue" @keyup="type"
  @keydown.enter.prevent="" @blur="change" />
</template>

<script>
export default {
}
</script>

<style lang="css">
</style>

<script>
export default {
  model: {
    prop: 'modelValue',
    event: 'input'
  },
  props: {
    modelValue: {
      default: undefined,
    },
    min: {
      default: undefined,
    },
    max: {
      default: undefined,
    },
  },
  computed: {
    value: {
      get: function() {
        if (this.modelValue !== undefined) {
          // console.log("get value", this.modelValue);
          return this.modelValue;
        } else {
          // console.log("get value !model", this.modelValue);
          return 0;
        }
      },
      set: function(value) {
        if (!value || value == NaN) {
          // console.log("set value NAN", value);
          value = 0;
        }
        // console.log("set value", value);
        // return value;
      }
    }
  },
  methods: {
    prepare(changedValue, evt) {
      this.formattedValue = this.format(changedValue);
      this.value = changedValue;
      evt.target.value = this.formattedValue;
      this.$emit('input', changedValue || 0);
    },
    change(evt) {
      var changedValue = evt.target.value;
      changedValue = this.checkInRange(this.unformat(changedValue));
      this.prepare(changedValue, evt);
    },
    type(evt) {
      // console.log("evt.target.value", evt.target.value);

      // When user select text in the document, also abort.
      var selection = window.getSelection().toString();
      if (selection !== '') {
        return;
      }
      // When the arrow keys are pressed, abort.
      // if ($.inArray(evt.keyCode, [38, 40, 37, 39]) !== -1) {
      if ([38, 40, 37, 39].indexOf(evt.keyCode) !== -1 ) {
        return;
      }
      var changedValue = this.unformat(evt.target.value);
      changedValue = this.checkMax(this.unformat(changedValue));
      this.prepare(changedValue, evt);
    },
    unformat(input) {
      // console.log("unformat", input);
      if (!input || input == NaN) {
        // console.log("unformat NAN", input);
        input = 0;
      }
      // console.log("unformat", parseInt(input.toString().replace(/[($)\s\._\-]+/g, '')));
      return parseInt(input.toString().replace(/[($)\s\._\-]+/g, ''));
    },
    format(input) {
      input = input.toString().replace(/[\D\s\._\-]+/g, "");
      input = input ? parseInt(input, 10) : 0;
      input = (input === 0) ? 0 : input.toLocaleString();
      return input;
    },
    checkInRange(input) {
      let min = parseInt(this.min);
      let max = parseInt(this.max);
      let val = parseInt(input);

      if ((min !== NaN) && (min >= val)) {
        val = min;
      } else if ((max !== NaN) && (max <= val)) {
        val = max;
      }
      return val;
    },
    checkMax(input) {
      let max = parseInt(this.max);
      let val = parseInt(input);

      if ((max !== NaN) && (max <= val)) {
        val = max;
      }
      return val;
    }
  },
  data() {
    return {
      formattedValue: ''
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue, oldValue) {
        // console.log("watchnewValue", newValue);
        // console.log("watcholdValue", oldValue);
        if (!newValue) {
          console.log("watch !value newValue", newValue);
          newValue = this.value = this.formattedValue || 0;
        } else {
          var formatted = this.format(newValue)
          if (formatted !== this.formattedValue) {
            this.formattedValue = formatted
          }
        }
      }
    }
  },
  // template: '<input type="text" :value="formattedValue" @keyup="type" @blur="change" />'
}
</script>



// WEBPACK FOOTER //
// src/components/money.vue